<div class="standard-catalogue-container">
  @if(showTitle) {
    <div class="standard-catalogue-title">
      {{ 'STANDARD-CATALOGUE.TITLE' | translate }}
    </div>

    <div
      class="standard-catalogue-text"
      [innerHTML]="'STANDARD-CATALOGUE.TEXT' | translate"
    ></div>
  }

  <div class="standard-training-categories-container">
    <dx-drop-down-box
      #standardCategoryDropDown
      [value]="standardTrainingCategoryIds"
      [dataSource]="standardTrainingCategories"
      [label]="('COMMON.FIELDS.STANDARD-CATEGORIES' | translate) + ' *'"
      displayExpr="name"
      valueExpr="id"
      [showClearButton]="true"
      [readOnly]="isViewMode"
      (onOpened)="openStandardCategoryModal()"
      (onValueChanged)="clearStandardCategory($event)"
    >
      <dx-validator validationGroup="customFields">
        <dxi-validation-rule
          type="required"
          [message]="'VALIDATIONS.STANDARD-CATEGORY-REQUIRED' | translate"
        ></dxi-validation-rule>
      </dx-validator>
    </dx-drop-down-box>
  </div>

  @if (standardTrainingCategoryIds.length === 0) {
    <div class="info-container category-required-container">
      <i
        class="dx-icon dx-svg-icon"
        [innerHTML]="getWarningIcon()"
      ></i>
      <span
        [innerHTML]="'STANDARD-CATALOGUE.STANDARD-CATEGORY-REQUIRED' | translate"
      ></span>
    </div>
  } @else {
    <div class="info-container training-catalogue-container">
      <i
        class="dx-icon dx-svg-icon"
        [innerHTML]="getBookIcon()"
      ></i>
      <span [innerHTML]="getStandardTrainingCatalogueText()"></span>
    </div>
  }
</div>

@if(showStandardCategoryModal) {
  <app-standard-category-selector-modal
    [(showModal)]="showStandardCategoryModal"
    [selectionMode]="'multiple'"
    [selectedCategoryIds]="standardTrainingCategoryIds"
    [standardCategories]="standardTrainingCategories"
    [usedStandardCategories]="usedStandardTrainingCategories"
    [showUsedStandardCategories]="true"
    (categoriesSelected)="onStandardCategoriesSelected($event)"
  ></app-standard-category-selector-modal>
}